













































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import ConfirmModalComponent from "@/components/shared/modals/ConfirmModal.vue";
import { Prop } from "vue-property-decorator";
import { SaleLineDto } from "@/application/dtos/app/erp/v3/sales/SaleLineDto";

@Component({})
export default class SaleLineRow extends Vue {
  @Prop({ default: -1 }) idx!: number;
  @Prop({ default: undefined }) item!: SaleLineDto;
  @Prop({ default: false }) disabled!: boolean;
  private collapsed: boolean = true;
  getRgbColor(item: SaleLineDto) {
    const color = item.product?.color?.split(",") ?? [];
    if (color && color.length === 3) {
      return `background-color:rgb(${color[0]},${color[1]},${color[2]})`;
    } else {
      return "";
    }
  }
  toggle() {
    this.collapsed = !this.collapsed;
  }
  edit(item) {
    if (!this.disabled) {
      this.$parent.$emit("edit", item);
    }
  }
  get isSale() {
    return this.item.type === "PR";
  }
}
